(ns motorsaif.i18n.ur)

(def ^:private validations
  {:business {:business {:business/name "کاروبار کا نام"
                         :business/location "مقام"
                         :business/media "تصاویر"}}
   ;; :login {:user/auth-identity "sf"}
   :request {:request {:request/location "مقام"
                       :request/coords "GPS مقام"
                       :request/media "تصاویر"
                       :request/description "تفصیل"
                       :request/category "زمرہ"}
             :car {:car/make "کار کی برانڈ"
                   :car/model "کار کا ماڈل"
                   :car/year "کار کا سال"}}})

(def malli {:missing-key "ضروری فیلڈ"
            :string {:not "ایک سٹرنگ ہونا چاہئے"
                     :min-is-max "کم از کم %1 حروف کا ہونا چاہئے"
                     :between "بیچ میں %1 سے %1 حروف کا ہونا چاہئے"
                     :min "کم از کم %1 حروف کا ہونا چاہئے"
                     :max "زیادہ سے زیادہ %1 حروف کا ہونا چاہئے"}
            :invalid-handle "ہینڈل میں خلا نہیں ہونا چاہئے یا بہت زیادہ لمبا نہیں ہونا چاہئے"
            :invalid-email "غلط ای میل"
            :require-images "براہ کرم تصاویر اپلوڈ کریں"})

(def dict
  {:malli malli

   :validation
   {:new-business (:business validations)
    :edit-business (:business validations)
    :edit-request (:request validations)
    :new-request (:request validations)}

   :time-ago
   {:day "%1 دن پہلے"
    :days "%1 دن پہلے"
    :hour "%1 گھنٹہ پہلے"
    :hours "%1 گھنٹے پہلے"
    :minute "%1 منٹ پہلے"
    :minutes "%1 منٹ پہلے"
    :seconds "%1 سیکنڈ پہلے"
    :just-now "ابھی"}

   :user
   {:status {:verified "تصدیق شدہ"
             :unverified "غیر تصدیق شدہ"}}

   :categories
   {:repairs "مرمت"
    :modifications "ترمیم"
    :parts "پرزے"}

   :footer
   {:test "%1 ہیلو"
    :motorsaif "موٹرسیف"
    :for-biz "کاروبار کے لئے"
    :browse "درخواستیں دیکھیں"
    :profile "پروفائل"
    :messages "پیغامات"
    :new-request "نئی درخواست"
    :account "اکاؤنٹ"
    :login "لاگ ان کریں"
    :sign-up "سائن اپ کریں"
    :usage "استعمال"
    :about "بارے میں"
    :terms "شرائط"
    :partners "شراکت دار"
    :privacy-policy "پرائیویسی پالیسی"}

   :nav
   {:profile "پروفائل"
    :welcome "خوش آمدید"
    :home "گھر"
    :new-request "نئی درخواست"
    :messages "پیغامات"
    :preview "پیش نظارہ فیڈ"
    :register "رجسٹر کریں"}

   :page
   {:not-found "صفحہ نہیں ملا"
    :home {:motorsaif "موٹرسیف"
           :headline "آٹو کیئر آسان بنایا"
           :tagline "اپنی آٹوموٹو درخواستوں کے لئے مقامی کاروبار سے حل حاصل کریں"
           :browse-requests "درخواستیں دیکھیں"
           :get-started "شروع کریں"
           :welcome "خوش آمدید %1"

           :login-signup  "لاگ ان / سائن اپ کریں"

           :modifications
           {:title "ترمیم"
            :description "کارکردگی میں اضافہ، پیچھے کیمرہ، انفوٹینمنٹ، یا ساؤنڈ سسٹم حاصل کریں"}
           :repairs
           {:title "مرمت"
            :description "گیراجز سے رابطہ کریں جو آپ کی کار کی کسی بھی مسئلہ کو ٹھیک کر سکتے ہیں"}
           :parts
           {:title "پرزے"
            :description "آپ کو درکار پرزے سکریپ یارڈز اور پرزہ دکانوں سے حاصل کریں"}}
    :feed {:header "درخواستیں"
           :all-requests "تمام درخواستیں دکھائی جا رہی ہیں"
           :no-results "موجودہ تلاش کے ساتھ کوئی درخواست نہیں ملی۔ مزید اختیارات شامل کریں یا انہیں سب صاف کریں۔"}

    :forgot-password {:title "پاسورڈ بھول گئے"
                      :subtitle "جاری رکھنے کے لئے اپنا ای میل درج کریں۔ آپ اگلے مرحلے میں لاگ ان کرنے کے لئے ایک کوڈ داخل کریں گے۔"
                      :email-placeholder "ای میل"
                      :submit {:button "کوڈ بھیجیں"
                               :email-not-registered "ای میل رجسٹر نہیں ہے"}}

    :login {:title "لاگ ان کریں"}
    :sign-up {:title "اکاؤنٹ بنائیں"
              :subtitle "شروع کرنے کے لئے ایک نیا صارف کے طور پر رجسٹر کریں"}

    :request
    {:header "%1 درخواست"
     :share "شئیر کریں"
     :share-action {:title "کار سروس کی درخواست"
                    :text "کار سروس کی درخواست"}
     :description "تفصیل"
     :message "پیغام"
     :request-id "درخواست ID"
     :filters "فلٹرز"
     :request-type "درخواست کی قسم"
     :category "زمرہ"
     :vehicle "گاڑی"
     :clipboard {:title "کلپ بورڈ میں کاپی کریں"
                 :copied "کاپی ہو گیا!"
                 :fail "کاپی کرنے میں ناکام"}
     :condition "حالت"
     :not-found {:heading "درخواست نہیں ملی۔"
                 :helper "درخواست حل ہو گئی، حذف ہو گئی، یا غیر درست ہے"}}

    :new-request
    {:header "نئی درخواست بنائیں"
     :submit {:created {:title "درخواست بن گئی!"
                        :message "آپ کی درخواست کامیابی کے ساتھ بن گئی ہے"}
              :invalid {:title "براہ کرم نیچے دیئے گئے مسائل کو حل کریں"}}}

    :edit-request
    {:header "درخواست میں ترمیم کریں"
     :submit {:created {:title "درخواست محفوظ ہو گئی!"
                        :message "آپ کی درخواست کامیابی کے ساتھ محفوظ ہو گئی ہے"}
              :invalid {:title "براہ کرم نیچے دیئے گئے مسائل کو حل کریں"}}}

    :edit-profile {:header "پروفائل میں ترمیم کریں"}

    :profile
    {:profile "پروفائل"
     :alerts-off "الرٹس بند کریں"
     :nothing-to-show "ابھی تک یہاں دکھانے کے لئے کچھ نہیں"
     :alerts "الرٹس"
     :logout "لاگ آوٹ"
     :active "فعال"
     :history "تاریخ"
     :role {:select "اکاؤنٹ منتخب کریں"
            :personal {:title "ذاتی اکاؤنٹ"
                       :description "آپ کے اپنے نجی کار مسائل کے لئے"}
            :business {:title "کاروباری اکاؤنٹ"
                       :description "درخواستوں کے جواب دے کر گاہکوں کو حاصل کریں"}}}

    :chat {:is-typing "ٹائپ کر رہا ہے"
           :online "آن لائن"
           :type-placeholder "اپنا پیغام ٹائپ کریں"
           :last-seen "آخری دفعہ دیکھا گیا %1"
           :media {:choose-images "تصاویر منتخب کریں"
                   :max-4 "زیادہ سے زیادہ 4 تصاویر"
                   :send "بھیجیں"
                   :upload-media "میڈیا اپلوڈ کریں"}}

    :messages
    {:empty-responded "آپ نے ابھی تک کسی کو جواب نہیں دیا۔"
     :empty-responses "ابھی تک کوئی جواب نہیں"
     :show-request "درخواست دکھائیں"
     :empty-requests "آپ نے ابھی تک کوئی درخواست \nنہیں بنائی ہے"
     :my-responses "میرے جوابات"
     :live-chat "لائیو چیٹ"
     :my-requests "میرے جوابات"
     :media "%1 میڈیا"
     :inbox "ان باکس"
     :requester-threads {:title "درخواست"
                         :description "آپ کی درخواست کے تمام جوابات"}}
    }

   :domain
   {:request {:status {:state {:expired "میعاد ختم ہو گئی"
                               :active "فعال"
                               :deleted "حذف ہو گیا"
                               :resolved "حل ہو گیا"}
                       :action {:active "فعال کریں"
                                :deleted "حذف کریں"
                                :resolved "حل کریں"}}}

    :request-type
    {:repair "مرمت"
     :part "پرزہ"
     :upgrade "ترقی"}

    :part-condition
    {:new "نیا"
     :used "استعمال شدہ"
     :either "نیا یا استعمال شدہ"}}

   :forms
   {
    :forgot-password {:email-placeholder "ای میل"
                      :submit {:button "کوڈ بھیجیں"
                               :email-not-registered "ای میل رجسٹر نہیں ہے"}}

    :sign-up {:username {:description "آپ کا یوزر نیم منفرد ہے اور سب کو دکھائی دے گا۔"
                         :placeholder "یوزر نیم"
                         :available "دستیاب"
                         :taken "یوزر نیم لے لیا گیا"}
              :email {:placeholder "ای میل"}
              :password {:placeholder "پاسورڈ"}
              :existing-account {:have "پہلے سے ایک اکاؤنٹ ہے؟ "
                                 :sign-in "سائن ان کریں"}
              :submit {:button "جاری رکھیں"
                       :already-registered {:title "پہلے سے رجسٹرڈ"
                                            :message "یہ ای میل پہلے سے رجسٹرڈ ہے۔ لاگ ان پر کلک کریں۔"}}}

    :login  {:identity-placeholder "یوزر نیم یا ای میل"
             :password-placeholder "پاسورڈ"
             :submit {:button "لاگ ان کریں"
                      :wrong-credentials "غلط یوزر نیم یا پاسورڈ"}
             :forgot-password "پاسورڈ بھول گئے"
             :sign-up {:new "موٹرسیف میں نئے ہیں؟"
                       :create "اکاؤنٹ بنائیں"}
             :create-account "اکاؤنٹ بنائیں"}

    :edit-profile {:username {:title       "یوزر نیم"
                              :description "منفرد یوزر نیم جو صرف آپ کا ہے"}

                   :name     {:title       "نام"
                              :description "آپ کا اصلی نام"}

                   :email    {:title "ای میل"}

                   :phone    {:title       "فون"
                              :description "ہم آپ کا فون نمبر عوامی طور پر ظاہر نہیں کریں گے"}

                   :password {:change  {:title       "پاسورڈ تبدیل کریں"
                                        :description "اختیاری طور پر پاسورڈ تبدیل کریں"}
                              :confirm {:title "پاسورڈ کی تصدیق"}}

                   :submit {:button "معلومات اپ ڈیٹ کریں"}}

    :car {:title "کار کی تفصیلات"
          :choose "کار کا انتخاب کریں"
          :new "نیا شامل کریں"
          :year {:title "سال"
                 :placeholder "سال منتخب کریں"}
          :make {:title "برانڈ"
                 :placeholder "برانڈ منتخب کریں"}
          :model {:title "ماڈل"
                  :placeholder "ماڈل منتخب کریں"}
          :vin {:title "VIN"
                :placeholder "گاڑی کی شناختی نمبر"
                :description "اختیاری"}}

    :request {:upgrade {:category {:title "زمرہ"
                                   :description "ایک زمرہ منتخب کریں جو آپ کی مطلوبہ اپ گریڈ کے لئے بہترین ہو"}
                        :textarea {:title "تفصیل"
                                   :description "آپ اپنی کار کو کیسے اپ گریڈ کرنا چاہتے ہیں"
                                   :placeholder "ٹربو، ساؤنڈ سسٹم، انفوٹینمنٹ، وغیرہ"}}

              :repair {:category {:title "زمرہ"
                                  :description "ایک زمرہ منتخب کریں جو آپ کی مطلوبہ مرمت کے لئے بہترین ہو"}
                       :textarea {:title "تفصیل"
                                  :description "وضاحت کریں کہ کیا مرمت کی ضرورت ہے"
                                  :placeholder "آپ کی کار میں کیا خرابی ہے"}}

              :part {:category {:title "زمرہ"
                                :description "ایک زمرہ منتخب کریں جو آپ کے مطلوبہ پرزوں کے لئے بہترین ہو"}
                     :textarea {:title "تفصیل"
                                :description "مختصراً وضاحت کریں کہ آپ کو کیا چاہئے"
                                :placeholder "آپ کو کون سے پرزے چاہئے"}
                     :condition {:title "حالت"
                                 :description "آپ کو اپنے پرزے کس حالت میں چاہئے"}}

              :posting-as {:title "بطور پوسٹنگ"
                           :personal "%1 (ذاتی)"
                           :business "%1 (کاروبار)"}
              :request-type "درخواست کی قسم"
              :choose-request-type "درخواست کی قسم منتخب کریں"
              :media {:title "میڈیا"
                      :description "اختیاری طور پر کچھ تصاویر اپ لوڈ کریں"}
              :gps {:locating "مقام معلوم کر رہا ہے"
                    :jump "موجودہ مقام پر جائیں"}
              :location {:title "مقام"
                         :drop-pin "اپنے موجودہ مقام پر ایک پن چھوڑیں"
                         :description "آپ کا عین مقام نجی ہوگا، کاروبار کو آپ کے قریب تر تلاش کرنے کے لئے استعمال ہوگا"}}

    :general
    {:create "بنائیں"
     :optional "اختیاری"
     :backend-error "بیک اینڈ سرور کی خرابی"
     :save "محفوظ کریں"}}

   :install-pwa
   {:title "ایپ کے ساتھ درخواستوں کے ساتھ باخبر رہیں"
    :button "انسٹال کریں"}

   :general
   {:english "انگریزی"
    :loading "لوڈ ہو رہا ہے"
    :request "درخواست"
    :unread "غیر پڑھے: "
    :hold-to-confirm "تصدیق کرنے کے لئے دبائے رکھیں"
    :filters "فلٹرز"
    :arabic "عربی"
    :arabee "العربية"
    :offline "آف لائن - دوبارہ جڑ رہا ہے..."}
   })
